__webpack_require__.p = "/frontend/dist/user/";